
// 客户编码、客户名称、客户经理/开发人、客户系、客户等级、行业大类、细分行业、内外渠、
// 客户状态、开发单位、创建人、创建时间
export const fieldsConfig = {
    name: 'businessDialog',
    fields: [

        {
            label: '客户名称',
            prop: 'customerName',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '社会信用代码',
            prop: 'societyCreditCode',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '法人代表',
            prop: 'ebcuLegalEntity',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '注册号',
            prop: 'ebcuBusinessNo',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '组织机构代码',
            prop: 'ebcuOrgBarcode',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '纳税人识别号',
            prop: 'ebcuTaxRegistNo',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '注册金额',
            prop: 'ebcuRegisteredCapital',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '成立日期',
            prop: 'ebcuRegistrationDate',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '经营状态',
            prop: 'regStatus',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '省',
            prop: 'ebcuEbplProvinceName',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '市',
            prop: 'ebcuEbplCityName',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '区',
            prop: 'ebcuDistrictsName',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '注册地址',
            prop: 'ebcuAddress',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '天眼参考行业',
            prop: 'tycIndustry',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '人员规模',
            prop: 'staffNumRange',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '参保人数',
            prop: 'socialStaffNum',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '是否小微企业',
            prop: 'isMicroEnt',
            labelWidth: '120px',
            type: 'custom',
            optionsKey: 'SYS_YES_NO'
        },
        {
            label: '企业类型',
            prop: 'companyOrgType',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '实收注册资金',
            prop: 'actualCapital',
            labelWidth: '120px',
            type: 'custom'
        },

        {
            label: '电话',
            prop: 'ebcuTel',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '电子邮箱',
            prop: 'ebcuEmail',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '网址',
            prop: 'companyUrl',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '英文名',
            prop: 'ebcuNameEn',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '简称',
            prop: 'customerShortName',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '经营范围',
            prop: 'businessScope',
            labelWidth: '120px',
            type: 'custom'
        }

    ],
    height: 325

};
